import { parseExtraArray1 } from "./crmDaysInStage";

export function getLeadCompliance(lead) {
  const extra = parseExtraArray1(lead?.extraArray1);
  const c = extra.compliance || {};
  return {
    consent: c.consent !== false,
    dnd: Boolean(c.dnd),
    note: c.note || "",
  };
}

export function isContactBlocked(lead) {
  return getLeadCompliance(lead).dnd;
}

export function getLeadAttribution(lead) {
  const extra = parseExtraArray1(lead?.extraArray1);
  return extra.attribution || null;
}

export function getLeadCustomFields(lead) {
  const extra = parseExtraArray1(lead?.extraArray1);
  return extra.customFields || {};
}

export function getLeadProductInquiry(lead) {
  const extra = parseExtraArray1(lead?.extraArray1);
  const fromExtra = extra?.productInquiry;
  if (fromExtra?.product_name) {
    return {
      productName: fromExtra.product_name,
      productId: fromExtra.product_id || null,
      productSku: fromExtra.product_sku || null,
    };
  }

  const type = String(lead?.type || "").trim();
  const description = String(lead?.description || "").trim();
  if (type === "Product Inquiry" || description.startsWith("Inquiry about:")) {
    const match = description.match(/^Inquiry about:\s*(.+?)(?:\s*\(SKU:\s*([^)]+)\))?$/i);
    if (match) {
      return {
        productName: match[1].trim(),
        productId: null,
        productSku: match[2]?.trim() || null,
      };
    }
  }

  return null;
}

export function getLeadProductName(lead) {
  return getLeadProductInquiry(lead)?.productName || "";
}

export function captureUtmFromUrl() {
  if (typeof window === "undefined") return null;
  const params = new URLSearchParams(window.location.search);
  const utm = {
    utm_source: params.get("utm_source") || "",
    utm_medium: params.get("utm_medium") || "",
    utm_campaign: params.get("utm_campaign") || "",
    utm_term: params.get("utm_term") || "",
    utm_content: params.get("utm_content") || "",
  };
  if (!utm.utm_source && !utm.utm_medium && !utm.utm_campaign) return null;
  try {
    sessionStorage.setItem("crm_utm", JSON.stringify(utm));
  } catch {
    /* ignore */
  }
  return utm;
}

export function readStoredUtm() {
  try {
    const raw = sessionStorage.getItem("crm_utm");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}
